import { render, staticRenderFns } from "./StepMarker.vue?vue&type=template&id=5e12c80c&scoped=true&"
import script from "./StepMarker.vue?vue&type=script&lang=js&"
export * from "./StepMarker.vue?vue&type=script&lang=js&"
import style0 from "./StepMarker.vue?vue&type=style&index=0&id=5e12c80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12c80c",
  null
  
)

export default component.exports